"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const react_1 = __importDefault(require("react"));
const uniqBy_1 = __importDefault(require("lodash/uniqBy"));
const core_1 = require("@material-ui/core");
const checkboxUnchecked_1 = __importDefault(require("../../../../../svgIcons/checkboxUnchecked"));
const Parent = (props) => {
    const { classes, data, filters, getExperts, getServiceExperts, type, directoryType } = props;
    const requestType = directoryType === 'serviceExperts' ? getServiceExperts : getExperts;
    const changedFilters = cloneDeep_1.default(Object.assign(Object.assign({}, filters), { offset: 0 }));
    const singleCheckboxChecked = data.singleCheckbox && !!filters[type].find(f => f.id === data.id);
    const totalSelectedCount = filters[type].filter(f => f.parent_id === data.id).length;
    const fullSelected = !data.singleCheckbox && totalSelectedCount === data.subCategories.length;
    const partiallySelected = totalSelectedCount >= 1 && totalSelectedCount < data.subCategories.length;
    const [checked, onChange] = react_1.default.useState(fullSelected || partiallySelected || false);
    const handleChange = (e) => {
        const existedSubCategoryLen = data.subCategories.length;
        const selectedSubCategoriesLen = (changedFilters[type].filter(i => i.parent_id == data.id)).length || existedSubCategoryLen;
        const check = (existedSubCategoryLen && !fullSelected && !partiallySelected && checked) ? false : checked;
        const isChecked = !check;
        onChange(!check);
        if ((isChecked && (selectedSubCategoriesLen === existedSubCategoryLen)) ||
            (selectedSubCategoriesLen !== existedSubCategoryLen)) {
            changedFilters[type] = uniqBy_1.default([].concat(changedFilters[type], !data.singleCheckbox ? data.subCategories : data), v => [v.id, v.parent_id].join());
        }
        else {
            changedFilters[type] = changedFilters[type].filter(f => !data.singleCheckbox ? f.parent_id !== data.id : f.id !== data.id);
        }
        requestType(changedFilters);
        e.preventDefault();
    };
    const checkedIcon = fullSelected || singleCheckboxChecked ?
        react_1.default.createElement("span", { className: classes.checkedIcon }) : partiallySelected ?
        react_1.default.createElement("span", { className: classes.checkedParentPart }) : react_1.default.createElement(checkboxUnchecked_1.default, null);
    return (react_1.default.createElement("div", { className: classes.labelContainer },
        react_1.default.createElement("div", null,
            react_1.default.createElement(core_1.Checkbox, { disableRipple: true, value: data.name, id: `${data.id}`, checked: checked || fullSelected || partiallySelected, className: classes.checkbox, onClick: handleChange, icon: react_1.default.createElement(checkboxUnchecked_1.default, null), checkedIcon: checkedIcon })),
        react_1.default.createElement("div", null,
            react_1.default.createElement("label", { style: { cursor: "pointer" }, htmlFor: '', className: classes.labelText }, data.name))));
};
exports.default = Parent;
